export const Storage = Object.freeze({
  // Auth & user
  auth: "simplize_auth",
  access_token: "access-token",
  refresh_token: "refresh-token",
  expired_time: "expired-time",
  current_user: "simplize_current_user",
  super_agent_user_id: "super_agent_user_id",

  // Chat
  active_session_id: "active_session_id",
  chat_mode: "chat_mode",
  chat_model: "simplize_chat_model",

  // UI
  app_theme: "app_neb_theme",
  sidebar_is_open: "sidebar_is_open",
  right_panel_is_open: "right_panel_is_open",

  // Greeting
  greeting_cache: "greetingCache",
  recent_greetings: "recentGreetings",
  has_visited: "hasVisited",
  last_visit: "lastVisit",

  // Chat assistant
  assistant_mode: "chat_assistant_mode",
  assistant_floating_size: "chat_assistant_floating_size",
  assistant_sidebar_width: "chat_assistant_sidebar_width",
  assistant_last_session: "chat_assistant_last_session",
  assistant_is_open: "chat_assistant_is_open",

  // Dev agent selection
  dev_agent_id: "chat_dev_agent_id",
  dev_agent_name: "chat_dev_agent_name",

  // Insights
  insights_session_id: "insights:session_id",

  // Portfolio AI (Nebula)
  quote_cache: "portfolio-ai:quoteCache",
  nebula_stat_method: "nebula_stat_method",
  nebula_last_tier: "nebula:lastTier",
  nebula_guide_seen: "nebula_guide_seen",

  // Home market data cache
  market_data: "simplize_market_data",
  vnindex_data: "simplize_vnindex_data",
});

export const PERSIST_ON_LOGOUT_PREFIXES = [Storage.nebula_guide_seen];
